import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './tufts-card-promo.css.lit';
import tuftsCardComponentStyle from '../tufts-card/tufts-card.css.lit';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import '../tufts-card/tufts-card';
import '../tufts-button/tufts-button';
import { tuftsCard } from '../tufts-card/tufts-card';

/**
 * The Tufts Card Promo component
 * @element tufts-card-promo
 * @summary Tufts Card Promo component
 *
 * @dependency tufts-heading
 *
 * @slot media - image or video
 * @slot eyebrow - Used for eyebrow heading
 * @slot heading
 * @slot description - Used for summary
 * @slot cta-1 - Link for first CTA button
 * @slot cta-2 - Link for second CTA button
 *
 * @attr media-side
 * @attr background
 */

@customElement('tufts-card-promo')
export class tuftsCardPromo extends tuftsCard {
  static styles: CSSResultGroup = [
    tuftsCardComponentStyle,
    componentStyles,
    tuftsHeadingCssLit,
  ];

  firstUpdated(): void {
    this.checkParentNodeContainer();
  }

  secondaryContentTemplate(): TemplateResult {
    const classes = {
      content: true,
      [this.setColorTemplate()]: true,
      mobile: this.isMobile,
    };
    return html` <style>
        .content {
          --card-background: ${'var(--bg-color--' + this.background + ')'};
        }
      </style>
      <div class="${classMap(classes)}">
        ${this.ngSlot.conditionalNGSlot('eyebrow', true, 'xs')}
        ${this.ngSlot.conditionalNGSlot('heading', true, 'lg')}
        ${this.ngSlot.conditionalNGSlot('description')}
        ${this.ngSlot.conditionalNGSlot('icon-links')}
        ${this.ctaTemplate1('cta-1', this.setColorTemplate())}
        ${this.ctaTemplate2('cta-2', this.setColorTemplate())}
      </div>`;
  }

  regularOrderTemplate(): TemplateResult {
    const classes = {
      'media-content': true,
      'mobile': this.isMobile,
    };
    return html`
      <div slot="primary-content" class="${classMap(classes)}">
        ${this.ngSlot.conditionalNGSlot('media')}
      </div>
      <div slot="secondary-content" class="secondary-content">
        ${this.secondaryContentTemplate()}
      </div>
    `;
  }

  reverseOrderTemplate(): TemplateResult {
    const classes = {
      'media-content': true,
      'mobile': this.isMobile,
    };
    return html`
      <div slot="secondary-content" class="secondary-content">
        ${this.secondaryContentTemplate()}
      </div>
      <div slot="primary-content" class="${classMap(classes)}">
        ${this.ngSlot.conditionalNGSlot('media')}
      </div>
    `;
  }
}
